import type { UserAuthData } from './permissions.types'
import type { AuthUser } from '@/hooks/auth/use-auth'

export function buildAuthUser(decoded: UserAuthData): AuthUser {
  return {
    user_id: decoded.user_id,
    context_revision: decoded.context_revision,
    uuid: decoded.user_id,
    tenant_id: decoded.tenant_id,
    email: decoded.email || '',
    name: decoded.name || '',
    role: decoded.role,
    permissions: decoded.permissions,
    disabled_permissions: decoded.disabled_permissions || [],
    timezone: decoded.timezone || 'UTC',
    ui_locale: decoded.ui_locale ?? null,
    uses_dst: decoded.uses_dst ?? false,
    // Display profile comes from the server session, never decoded browser claims.
    email_verified: decoded.email_verified,
    // Platform-tenant UI hint; server boundaries independently check the real gate.
    is_platform_tenant: decoded.is_platform_tenant,
    // integrator is admin-level → folded into isManager/isAdmin so it sees the
    // same tenant-admin UX. isSuperUser stays strict: it gates platform-only
    // surfaces that integrator must NOT see.
    isManager: decoded.role === 'manager' || decoded.role === 'admin' || decoded.role === 'integrator' || decoded.role === 'super_user',
    isAdmin: decoded.role === 'admin' || decoded.role === 'integrator' || decoded.role === 'super_user',
    isSuperUser: decoded.role === 'super_user',
    isIntegrator: decoded.role === 'integrator',
    ...(decoded.impersonated_tenant_id ? { impersonated_tenant_id: decoded.impersonated_tenant_id } : {}),
  }
}
